exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disabled[data-v-42f3c8f3]{opacity:.5\n}", ""]);

// exports
